import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Sidebar from '../Sidebar/Sidebar'
import {
  saveCollectionItem,
  fetchCollectionItemInputs
} from '../../services/collectionItemsService'
import './Collection.css'
import Loader from "react-loader-spinner";
class CollectionList extends Component {

    constructor(props) {
      super(props);
      this.handleOnChange = this.handleOnChange.bind(this);
    }
    state = { 
      user:{},
      inputs:[],
      files:[],
      isFetching:true,
      toggleFiles:false,
      showKey:"",
      formData: {},
      collection: null,
      successful: false,
      error:false,
      submitting:false,
      fileName:"",
     }
     
     async componentDidMount(){
      let loggedInUser = localStorage.getItem('currentUser')
      let { id  } = this.props.match.params
      let response = await fetchCollectionItemInputs(id)
      let {inputs , files} = await response.data
      this.setState({inputs ,files})
      this.setState({isFetching:false})
      this.setState({user:loggedInUser})
      this.setState({
        collection: id
      })
     };
    
     submitData = async (e) =>{
       this.setState({submitting:true})
       e.preventDefault()
       const {
         formData,
         collection,
       } = this.state;
        const _formData = new FormData();
        if (Object.keys(formData).length) {
          Object.keys(formData).map((key, index) => {
            Object.keys(formData[key]).map((i) => {
              if(key === 'categories'){
                _formData.append("".concat(key).concat("[").concat(i).concat("]"), formData[key][i]);
              } else {
                _formData.append("input[".concat(key).concat("][").concat(i).concat("]"), formData[key][i]);
              }
            });
          });
        }
         try {
           const response = await saveCollectionItem(_formData, collection);
           if(response.status === 201){
            let { collection:col } = this.props.match.params
             this.setState({successful:true ,submitting:false})
             setTimeout(function(){ 
                window.location.href=`/departments/${col}`
              }, 1000);
           }
         } catch (error) {
            this.setState({error:true , submitting:false})
         }
     }
     closeSuccessful = () =>{
      let { collection } = this.props.match.params
      this.setState({successful: false})
      window.location.href=`/departments/${collection}`
    }
    closeError = () =>{
       this.setState({error: false})
    }
     handleOnChange(e) {
       const elem = e.target;
       const {formData} = this.state;
       if (formData[elem.type] === undefined) {
         formData[elem.type] = {}
       }
       let value = elem.value;
       if (elem.type === 'file') {
          const category = e.target.dataset.category;
          if (formData['categories'] === undefined) {
            formData['categories'] = {}
          }
          formData['categories'][elem.name] = category;
          value = elem.files[0];
       }else if(elem.type==='select-one'){
         formData[elem.type][elem.name] = value;
        }
        formData[elem.type][elem.name] = value;
        this.setState({formData});
     }

     toggleFileForPersonalFiles = (key) =>{
       let {files , toggleFiles} = this.state
       Object.keys(files).forEach(file=>{
        if(file === key){
          this.setState({showKey:file})
          this.setState({toggleFiles:!toggleFiles})
        }
       })

     }
     handleOnSelectFileTypeChange = (e) =>{
        this.setState({fileName:e.target.value})
     }
     toggleFileForNonPersonalFiles = (name) =>{
      let {files , toggleFiles} = this.state
      files.forEach(file=>{
        if(file.name === name){
          this.setState({showKey:file.name})
          this.setState({toggleFiles:!toggleFiles})
        }
      })
     }

    render() { 
      let{user, inputs ,files , isFetching ,toggleFiles,showKey,successful ,error,submitting,fileName } = this.state
      let { title ,collection } = this.props.match.params
      let thisYear = new Date().getFullYear()
      let firstYear = 1980
        return ( 
            <div className="flex flex-row w-full">
               <div className=" p-4 bg-white  md:min-h-screen overflow-auto w-60 fixed">
                <Sidebar user={user}/>
                </div>
                <div className="py-8 px-8 ml-60 upPart relative lg:max-h-48 w-full">
                   <div className="">
                      <div className="text-white flex">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>
                        <Link to={`/departments/${collection}`}>
                          <span className="ml-2">
                             Go back to Collections Page
                          </span>
                        </Link>
                      </div>
                        <div className="mt-8">
                           <span className="text-2xl font-bold text-white">Create New {title} Collection Item</span>
                        </div>
                   </div>
                   <div style={{ width:'96%' }} className="collectionPart mt-4 lg:mt-20 grid h-96  overflow-x-auto">
                       
                         
                           <form  className="bg-white p-8 rounded-md" onSubmit={this.submitData}>
                              <React.Fragment>
                               {
                                  isFetching && 
                                  <div className="mx-20">
                                     <Loader
                                      type="Puff"
                                      color="#F35D2D"
                                      height={50}
                                      width={50} />
                                  </div>
                               }
                               <div className=" grid grid-cols-4  w-full gap-8 my-2 mb-4">
                                     {
                                   inputs.map(input=>{
                                    return (
                                        <div className="w-full flex flex-col">
                                           {
                                             input.type ==="select" ? 
                                             <React.Fragment>
                                               <label className="text-base text-black font-semibold">
                                                  {input.label}
                                                </label>
                                                <select type={input.type} name={input.name} onChange={this.handleOnChange} className="border-2 text-sm border-gray-200 rounded-md p-2">
                                                  <option selected disabled="disabled">select</option>
                                                  {
                                                    input.options.map(option=>{
                                                      return (                                                        
                                                          <option value={option} key={option.toString()}>
                                                             {option.toString()}
                                                          </option>
                                                      )                                                        
                                                    })
                                                  }
                                                </select>
                                             </React.Fragment>                                         
                                             :
                                             input.type === "textarea" ?
                                             <React.Fragment>
                                             <label className="text-base text-black font-semibold">
                                                {input.label}
                                           </label>
                                           <textarea type={input.type} name={input.name} placeholder={input.description} onChange={this.handleOnChange} id="" cols="30" rows="5" className=" text-xs p-3 border-2 border-wvrPrimary rounded-md "></textarea>
                                           </React.Fragment>:
                                             <React.Fragment>
                                              <label className="text-base text-black font-semibold">
                                              {input.label}
                                            </label>
                                              <input type={input.type}
                                              max={input.type === 'number' && input.label === 'Payroll Year' ? thisYear : ""}
                                              min={input.type === 'number' && input.label === 'Payroll Year' ? firstYear : ""}
                                              defaultValue={input.initialValue ? input.initialValue : ""}
                                              required={input.name==="title" ? "required":""}
                                              name={input.name} placeholder={input.description} onChange={this.handleOnChange} className=" text-xs p-3 border-2 border-wvrPrimary rounded-md "/>
                                            </React.Fragment> 
                                         
                                             
                                           }
                                        </div>
                                      )
                                    })
                                 }
                                </div>
                                {
                                  !isFetching && <span className="text-xl font-extrabold">Documents To Upload</span>
                                }
                               <div className=" grid grid-cols-2  w-full gap-8 my-2 mb-4">
                                   {
                                     title === "Personal Staff Files" ? 
                                     Object.keys(files).map((key)=>{
                                      return(
                                       <div key={files[key].category} className="w-full flex flex-col">
                                         <div onClick={()=>this.toggleFileForPersonalFiles(files[key].category)} className="flex bg-gray-200 p-4 rounded-md cursor-pointer">
                                           <span className="text-lg  text-gray-600 font-semibold">{files[key].category}</span>
                                         </div>
                                         {
                                           (toggleFiles && showKey===files[key].category) && 
                                           <div className=" grid grid-cols-2  w-full gap-8 my-2 mb-4">
                                             {
                                                 files[key].subCategory.map(sub=>{
                                                   return(
                                                     <div className="w-full flex flex-col">
                                                          <label className="text-sm" >{sub.label}</label>
                                                           <input type ="file" accept='application/pdf' name={sub.name} data-category={files[key].category} onChange={this.handleOnChange} className="text-xs mt-2"/>
                                                     </div>
                                                   )
                                               })
                                             }
                                           
                                         </div>
                                         }
                                       </div>
                                     )
                                   }) : 
                                    <React.Fragment>
                                     {
                                       files.length > 0 &&
                                       <div className="w-full flex flex-col mt-4">
                                         <label htmlFor="" className="text-sm">Select Sub Collection</label>
                                         <select  onChange={this.handleOnSelectFileTypeChange}   name="" id="" className="p-2 border-gray-800">
                                         <option value="" className="p-2 border-gray-800">
                                             Select ..
                                           </option>
                                      {
                                        
                                        files.map(file=>{
                                         return(
                                           <option value={file.name} className="p-2 border-gray-800">
                                             {file.name}
                                           </option>
                                          )
                                        })                             
                                        
                                      }
                                      </select>
                                      <input  type ="file" name={fileName}  onChange={this.handleOnChange} className="text-xs mt-2"/>
                                    </div>
                                     }
                                    </React.Fragment>
                                   }  
                               </div>
                                <hr />
                              </React.Fragment>
                              { 
                                !isFetching &&
                                <div className="flex flex-row gap-4 my-4">
                                <button disabled={submitting ? true :""} type="submit" className={!submitting ? "bg-wvrblue text-white py-2 px-8 rounded-md":"bg-blue-300 text-white py-2 px-8 rounded-md"}>
                                  {submitting ? "please wait ...":"Register New Collection Item"}
                                  </button>                                      
                              </div>
                              }
                           </form>
                           {
                         successful && (
                             <div className="fixed top-8 right-0 bg-wvrLightGreen w-80 text-xs z-20 border-2 border-wvrGreen rounded-md">
                                <div className="flex flex-row py-2 px-4 gap-4">
                                    <div className=" bg-wvrGreen p-1 rounded-md">
                                        <div className="bg-white rounded-full p-1">
                                            <p className="text-wvrGreen"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <p>New Item Saved Successfully</p>
                                    </div>
                                    <button className=" flex items-center" onClick={() => this.closeSuccessful ()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    </button>
                                </div>
                             </div>
                                )
                            }
                           {
                         error && (
                             <div className="fixed top-8 right-0 bg-red-500 w-80 text-xs z-20 border-2 border-red-800 rounded-md">
                                <div className="flex flex-row py-2 px-4 gap-4">
                                    <div className=" bg-red-500 p-1 rounded-md">
                                        <div className="bg-white rounded-full p-1">
                                            <p className=""><svg className="w-5 h-5 cursor-pointer text-red-500" onClick={() => this.closeError ()} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg></p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-white">An Error occured...please fill all forms and  try again</p>
                                    </div>
                                </div>
                             </div>
                                )
                            }
                        </div>
                     </div>  
                   </div>
        )
    }
}
 
export default CollectionList;